import styled from "styled-components";

// --- NOVO WRAPPER PARA OS ÍCONES ---
// Este componente envolve os ícones e aplica os estilos de cor e tamanho
export const IconWrapper = styled.div`
  color: #1c779f; /* Cor principal dos ícones */
  font-size: 60px; /* Tamanho dos ícones */
`;

export const MainTitle = styled.h2`
  color: #f1b75c;
  font-family: "Staatliches", sans-serif;
  font-size: 3em;
  margin: 1.7rem;
  text-align: center;
`;

export const ContainerAboutUs = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 3rem 5%;
  text-align: center;

  h1,
  h2 {
    color: #f1b75c;
    font-family: "Staatliches", sans-serif;
    font-size: 3em;

    margin-bottom: 1.7rem;
  }

  .main-description {
    max-width: 800px;
    font-size: 1.3rem;
    line-height: 1.7;
    color: #555;
    margin-bottom: 1rem;
  }
`;

export const SectionCultura = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
  width: 100%;
  max-width: 1200px;
`;

export const CardCultura = styled.div`
  background-color: #fff;
  min-height: 250px;
  border-radius: 15px;
  border-top: 4px solid #a73129;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-8px) scale(1.07);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  }

  .card-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;

    h3 {
      font-size: 1.8rem;
      color: #333;
    }
  }

  p {
    font-size: 1.05rem;
    line-height: 1.6;
    color: #666;
  }
`;

export const ValoresList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 1rem;
  font-size: 1.05rem;
  line-height: 1.8;
  color: #666;

  li::before {
    content: "✓";
    margin-right: 10px;
    color: #a73129;
    font-weight: bold;
  }
`;

export const SectionAboutInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 3px;
  padding: 10px;
  flex-direction: row;
  margin: 0 auto;
  max-width: 1400px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ContainerInfoApresentation = styled.div`
  width: 600px;
  margin-right: 50px;
  p {
    font-size: 1.5rem;
    line-height: 1.9;
    color: #666;
  }
  @media (max-width: 768px) {
    width: 95%;
    margin: 0 auto;
  }
  span{
    font-weight: bold;
  }
`;

export const ContainerVideo = styled.div`
  height: 450px;
  overflow: hidden;
  border-radius: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BackgroundVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
